module.exports = __webpack_public_path__ + "img/CS48Q-中_10.fab67fa5.jpg";